import { AccountCategory } from '@phrasee/phrasee-typings/Graphql/interfaces'

export const routesPermissions = {
  accountsView: 'view:accounts-page',
  experimentsView: 'view:campaigns',
  reportsView: 'view:reports',
  accountSettingsView: 'view:accounts-settings-page',
  brandVoiceSettingsView: 'view:brand-voice-settings-page',
  usersView: 'view:users-page',
  projectsView: 'view:projects',
  projectsPageView: 'view:projects-page',
  contentView: 'view:languages-contents',
  languageView: 'view:languages-nodes',
  variantsEdit: 'edit:variants',
  dataSourcesCreate: 'create:personalization-data',
  demoPageView: 'view:poc-page',
}

export const experimentsPermissions = {
  create: 'create:campaigns',
  delete: 'delete:campaigns',
  edit: 'edit:campaigns',
  list: 'list:campaigns',
}

export const projectsPermissions = {
  create: 'create:projects',
  listRelation: 'list:projects.relation',
  list: 'list:projects',
}

export const accountsPermissions = {
  edit: 'edit:accounts',
}

export const usersPermissions = {
  create: 'create:users',
  delete: 'delete:users',
  deactivate: 'deactivate:users',
  edit: 'edit:users',
  list: 'list:users',
  view: 'view:users',
}

export const contentPermissions = {
  create: 'create:languages-contents',
}

export const permissions = {
  projectsCreate: 'create:projects',
  languageContentEdit: 'edit:languages-contents',
  ...routesPermissions,
}

export const getIsAuthorized = (
  permissions?: string[],
  accessPermission?: string
): boolean => {
  if (permissions?.length) {
    return accessPermission ? permissions.includes(accessPermission) : true
  } else {
    return false
  }
}

export const canAccessAccount = (
  categoryAccount: AccountCategory,
  accessPermission: string
) => {
  const permissions = categoryAccountMapping[categoryAccount]
  return permissions?.length ? permissions.includes(accessPermission) : false
}

// We do the mapping between the type of account and the permission given
export const categoryAccountMapping: { [key: string]: string[] } = {
  Starter: [],
  Pro: [
    'view:campaigns',
    'view:reports',
    'view:projects',
    'view:projects-page',
    'view:accounts-settings-page',
  ],
  Enterprise: [
    'view:campaigns',
    'view:reports',
    'view:projects',
    'view:projects-page',
    'view:accounts-settings-page',
  ],
}
